import { TStringArrayValuesObject } from "./../Interfaces/GlobalInterface"
import { TSubmitRequest } from "../Interfaces/DataInterface"
import { TStringValuesObject } from "../Interfaces/GlobalInterface"
import { IFormVal } from "../Elements/AdminForm/molecules/Forms/UserSideNewRequestForm"
import {
	isReactSelect,
	isReactSelectOptionArray,
	isReactSelectSingleOption,
	TReactSelectSelectedOptions,
} from "../Interfaces/ExternalComponentsInterfaces"

/**
 * When a user fills from and creates a request, form data is stoed as an object.
 * That object gets parsed for back-end where each key is "fieldId", and keys value is "value"
 * {name: "Matiss"} => {fieldId: "name", value: "Matīss"}
 * Array with all objects gets retured.
 */
const parseForSubmitRequest = (userRequestFormData: IFormVal): TSubmitRequest[] => {
	const arr: TSubmitRequest[] = new Array()
	Object.keys(userRequestFormData).map((key: string) => {
		const parsedValue = parseVal(userRequestFormData[key])

		const item: TSubmitRequest = {
			fieldId: key,
			value: parsedValue,
		}
		arr.push(item)
	})
	return arr
}

export default parseForSubmitRequest

const parseVal = (
	val: string | string[] | TReactSelectSelectedOptions
): string | number | string[] => {
	try {
		if (val == null) return ""
		if (typeof val === "string") return val
		if (typeof val === "number") return val
		if (isReactSelect(val) && isReactSelectOptionArray(val)) return val.map(({ value }) => value)
		if (isReactSelect(val) && isReactSelectSingleOption(val)) return val?.value

		return val
	} catch (err) {
		return ""
	}
}
